import cx from "classnames";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";

type CardContentProps = BoxProps & {
  fullbleed?: boolean;
  hasHeader?: boolean;
};

const CardContent = ({ className, fullbleed, hasHeader, ...props }: CardContentProps) => {
  const contentClass = cx(
    styles.content,
    fullbleed && styles.fullbleed,
    hasHeader && styles.hasHeader,
    className
  );

  return <Box direction="column" className={contentClass} {...props} fullWidth />;
};

CardContent.displayName = "DS.Card.Content";

export default CardContent;
